import { List, Map, Record } from 'immutable';
import {
  Utils,
  selectHasRoleSchedulerAdmin,
  selectHasRoleSchedulerManager,
} from '@kineticdata/bundle-common';
import { NOTIFICATIONS_FORM_SLUG } from '../../redux/modules/settingsNotifications';
import { ROBOT_FORM_SLUG } from '../../redux/modules/settingsRobots';
const { noPayload, withPayload } = Utils;
const ns = Utils.namespaceBuilder('settings/settingsApp');

export const types = {
  FETCH_APP_DATA_REQUEST: ns('FETCH_APP_DATA_REQUEST'),
  FETCH_APP_DATA_COMPLETE: ns('FETCH_APP_DATA_COMPLETE'),
};

export const actions = {
  fetchAppDataRequest: noPayload(types.FETCH_APP_DATA_REQUEST),
  fetchAppDataComplate: withPayload(types.FETCH_APP_DATA_COMPLETE),
};

export const State = Record({
  loading: true,
  errors: List(),
  agreements: List(),
  agreementsMap: Map(),
  hasAdminFormsAccess: false,
  hasDatastoreAccess: false,
  hasTeamAccess: false,
  hasUserAccess: false,
  hasNotificationAccess: false,
  hasRobotAccess: false,
  hasCalendarAccess: false,
  hasSchedulerAccess: false,
  hasApprovalManagementAccess: false,
  isApprovalManager: false,
  isCustomerApprovalAdmin: false,
  hasCatalogManagementAccess: false,
  hasSurveyAccess: false,
});

export const reducer = (state = State(), { type, payload }) => {
  switch (type) {
    case types.FETCH_APP_DATA_REQUEST:
      return state.set('error', null);
    case types.FETCH_APP_DATA_COMPLETE:
      const formMap = (payload.forms || []).reduce(
        (map, form) => map.set(form.slug, form.authorization),
        Map(),
      );
      const agreements = List(payload.agreements)
        .push({ Agreement: 'AMS0608' })
        .sortBy(a => a.Agreement);
      const agreementsMap = agreements.reduce(
        (map, a) => map.set(a.Agreement, true),
        Map(),
      );
      // Can manage some approval groups
      const isApprovalManager = payload.me.memberships.some(m =>
        agreementsMap.has(m.team.name),
      );
      // Can manage all approval groups
      const isCustomerApprovalAdmin =
        payload.me.spaceAdmin ||
        Utils.isMemberOf(payload.me, 'Customer Approval Administrators');
      return (
        state
          .set('loading', false)
          .set('errors', List(payload.errors))
          .set('agreements', agreements)
          .set('agreementsMap', agreementsMap)
          .set(
            'hasAdminFormsAccess',
            payload.me.spaceAdmin || payload.adminFormsAccess,
          )
          .set('hasDatastoreAccess', payload.me.spaceAdmin && formMap.size > 0)
          .set('hasTeamAccess', payload.me.spaceAdmin || payload.me.isSMO)
          .set('hasUserAccess', payload.me.spaceAdmin)
          // Notifications available to users who have access to modify the notification form
          .set(
            'hasNotificationAccess',
            formMap.getIn([NOTIFICATIONS_FORM_SLUG, 'Modification']),
          )
          // Robots available to users who have access to modify the robot form
          .set(
            'hasRobotAccess',
            formMap.getIn([ROBOT_FORM_SLUG, 'Modification']),
          )
          // Schedulers available to scheduler admins or scheduler managers
          .set(
            'hasSchedulerAccess',
            selectHasRoleSchedulerAdmin(payload.me) ||
              selectHasRoleSchedulerManager(payload.me),
          )
          // Approval Management is available to approval managers and admins
          .set('isApprovalManager', isApprovalManager)
          .set('isCustomerApprovalAdmin', isCustomerApprovalAdmin)
          .set(
            'hasApprovalManagementAccess',
            isCustomerApprovalAdmin || isApprovalManager,
          )
          // Catalog Management is available to SMO team and catalog managers
          .set(
            'hasCatalogManagementAccess',
            payload.me.isSMO || payload.me.isCatalogManager,
          )
          // Survey Management is available to users who can manage the survey kapp
          .set(
            'hasSurveyAccess',
            !!payload.surveyKapp && Utils.isKappManageable(payload.surveyKapp),
          )
      );
    default:
      return state;
  }
};
